// removed by extract-text-webpack-plugin
module.exports = {"investmentFormHead":"src-components-SignUp-___InvestmentInfoRrf__investmentFormHead___2T10Q","textInputs":"src-components-SignUp-___InvestmentInfoRrf__textInputs___2lrrq","submitButtonContainer":"src-components-SignUp-___InvestmentInfoRrf__submitButtonContainer___LxSba","errorText":"src-components-SignUp-___InvestmentInfoRrf__errorText___3za2k"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SignUp/InvestmentInfoRrf.css
// module id = 985
// module chunks = 3